export interface SettlementTerms {
	id: string;
	value: string;
	settlementsBonusId: string;
	name: string;
	month: string;
	isSettled: string;
	comment: string;
	createBy: string | null;
	createAt: string;
	dietKind: string;
	calculateToCash: boolean;
	toDelete: boolean;
}

export enum SettlementKinds {
	MOBILITY_PACKAGE = 'mobility_package',
	FLIX = 'flix',
	SETTLEMENT = 'settlement',
}

export enum SettlementBonusKinds {
	FLIX = '1',
	TRAFFIC_TICKET = '2',
	DAMAGE_DEDUCTION = '3',
	REWARD = '4',
	DEDUCTION = '5',
	TICKET = '6',
	TAXI = '7',
	DAILY_WAGE = '8',
	BONUS = '9',
	COMMUTE_ALLOWANCE = '10',
	REFUND = '11',
	ALLOWANCE = '12',
	OTHER = '13',
	DAMAGE_REFUND = '15',
	INSURANCE = '17',
	RESERVATION = '18',
	MOBILITY_PACKAGE = '19',
}
